import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for creating a Confluence database.
 */

/**
 * Properties for the Confluence database creation command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to create a new Confluence Database.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence database with the specified content.
 */
export var ConfluenceDatabaseCreateCommand = createCommand('confluence-database-create-command');